import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAwe42cDnXAZBHylHf0OoPU7AiKEI-3EMw",
  authDomain: "vismal-site.firebaseapp.com",
  projectId: "vismal-site",
  storageBucket: "vismal-site.firebasestorage.app",
  messagingSenderId: "508887253596",
  appId: "1:508887253596:web:8a8ca5fe8f6ca75b2d5c99",
  measurementId: "G-MMCE49ZLMD",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { analytics, auth, db, storage };
